import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';

interface Props {
    background?: string,
    enabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Simple',
  props: {
    background: { default: 'var(--neutral-effect-scrim-opc)' },
    enabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { background: string, enabled?: boolean };



const {
    background,
} = toRefs(props);

return { __sfc: true,props, background }
}

})